<!-- @format -->

<template>
  <div class="ui">
    <div class="ui internally grid centered">
      <div class="ui container">
        <div class="ui equal width form">
          <div class="fields">
            <div class="field">
              <label>Username</label>
              <input type="text" v-model="userName" placeholder="Username" />
            </div>
            <div class="field">
              <label>Password</label>
              <input v-model="password" type="password" />
            </div>
            <div
              class="ui button"
              @click.prevent="submit"
              style="color: white"
              :color="!valid || loading ? 'grey' : 'black'"
              :disabled="loading"
            >
              Login
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { login } from "@/gateway";
import { errorResponse, errorResponseExcept } from "@servicestack/client";
export default {
  data() {
    return {
      image: {
        original: "",
      },
      isMobileDevice: false,
      // loading: false,
      sessionInfo: null,
      valid: true,
      responseStatus: null,
      userName: "",
      password: "",
      rules: {
        required: (value) => !!value || "Required.",
        min: (v) => v.length >= 8 || "Min 8 characters",
        emailMatch: () => "The email and password you entered don't match",
      },
    };
  },
  components: {},
  computed: {
    errorSummary() {
      return errorResponseExcept.call(
        this,
        Object.keys("userName,password".split())
      );
    },
    ...mapGetters(["loading"]), // ...mapGetters(["loading", "isAuthenticated"])
  },
  methods: {
    async submit() {
      if (this.$refs.form.validate()) {
        // this.loading = true;
        try {
          // this.$store.commit("loading", true);

          const redirectUrl = await login(
            "credentials",
            this.userName,
            this.password
          );
          //console.log(redirectUrl);
          if (redirectUrl.userId) {
            location.href = "/";
          }
          // location.href = redirectUrl;
        } catch (e) {
          this.responseStatus = e.responseStatus || e;
        } finally {
          // this.$store.commit("loading", false);
          //this.loading = false;
          //   this.$store.dispatch("getAllPortfolios");
        }
      }
    },

    session() {
      //  var rep = getSessionInfo();
      // return rep;
    },
  },

  async mounted() {
    // this.isMobile();
    if (
      window.location.protocol == "http:" &&
      window.location.host !== "localhost:8080"
    ) {
      window.location.href =
        "https://" + window.location.host + window.location.pathname;
    }
  },
};
</script>
